interface AuthUserLike {
  role?: string | null;
  isGlobalAdmin?: boolean | null;
}

const roleLooksAdmin = (role?: string | null): boolean => {
  if (!role) return false;
  return role.toLowerCase().includes('admin');
};

/**
 * Historically we allowed several "admin" heuristics to bypass user filtering.
 * That caused demo/admin accounts to see every user's entries. We now require
 * an explicit backend flag before opting into cross-user visibility.
 */
export const shouldLoadAllRecords = (
  authUser?: AuthUserLike | null,
  backendUser?: any
): boolean => {
  const role = (backendUser?.role || authUser?.role || '').toLowerCase();
  const isGlobalAdmin = backendUser?.is_superuser || authUser?.isGlobalAdmin || backendUser?.is_super_admin;
  const isHoAdmin = role.includes('ho_admin') || role.includes('company_admin') || role.includes('ho');

  const explicitOverride =
    backendUser?.can_view_all_form_data ||
    backendUser?.permissions?.includes?.('view_all_form_data');

  return Boolean(explicitOverride || isGlobalAdmin || isHoAdmin || role.includes('admin'));
};

export const resolveUserFilterId = (
  authUser?: AuthUserLike | null,
  backendUser?: any
): number | null => {
  if (!backendUser) {
    return null;
  }

  const rawId = backendUser.id ?? backendUser.user_id ?? backendUser.userId;
  if (rawId === null || rawId === undefined) {
    return null;
  }

  const parsedId = Number(rawId);
  return Number.isFinite(parsedId) ? parsedId : null;
};

export const adminHelpers = {
  roleLooksAdmin,
  shouldLoadAllRecords,
  resolveUserFilterId
};

